import listActions from 'src/modules/achievement/list/achievementListActions';
import AchievementService from 'src/modules/achievement/achievementService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/store';
import Message from 'src/view/shared/message';
import quizDestroyActions from 'src/modules/quiz/destroy/quizDestroyActions';

const prefix = 'ACHIEVEMENT_DESTROY';

const achievementDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: achievementDestroyActions.DESTROY_STARTED,
      });

      await AchievementService.destroy(id);

      dispatch({
        type: achievementDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.achievement.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/achievement');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: achievementDestroyActions.DESTROY_ERROR,
      });
    }
  },
};

export default achievementDestroyActions;
